import {useMutation} from 'react-query';
import {useLocation, useNavigate} from 'react-router-dom';
import {sendRplyMSG} from 'services/farm/sendReplyChat';

const useReplyMSG = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');

  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IUseHookReplyMSG) => {
      return sendRplyMSG(payload);
    },
    onSuccess: (data, {clearInput}) => {
      clearInput && clearInput();
      navigate(
        `/${isFarm ? 'farm' : 'wholesaler'}/chat-form/${data.chat_guid}`,
        {
          state: {
            name: data.contact_detail.name,
          },
        },
      );
    },
  });
  return {isLoading, mutate};
};

export default useReplyMSG;
